import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomization = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 18C1 17.0707 1 16.606 1.07686 16.2196C1.39249 14.6329 2.63288 13.3925 4.21964 13.0769C4.60603 13 5.07069 13 6 13C6.92931 13 7.39397 13 7.78036 13.0769C9.36712 13.3925 10.6075 14.6329 10.9231 16.2196C11 16.606 11 17.0707 11 18C11 18.9293 11 19.394 10.9231 19.7804C10.6075 21.3671 9.36712 22.6075 7.78036 22.9231C7.39397 23 6.92931 23 6 23C5.07069 23 4.60603 23 4.21964 22.9231C2.63288 22.6075 1.39249 21.3671 1.07686 19.7804C1 19.394 1 18.9293 1 18Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 18C13 17.0707 13 16.606 13.0769 16.2196C13.3925 14.6329 14.6329 13.3925 16.2196 13.0769C16.606 13 17.0707 13 18 13C18.9293 13 19.394 13 19.7804 13.0769C21.3671 13.3925 22.6075 14.6329 22.9231 16.2196C23 16.606 23 17.0707 23 18C23 18.9293 23 19.394 22.9231 19.7804C22.6075 21.3671 21.3671 22.6075 19.7804 22.9231C19.394 23 18.9293 23 18 23C17.0707 23 16.606 23 16.2196 22.9231C14.6329 22.6075 13.3925 21.3671 13.0769 19.7804C13 19.394 13 18.9293 13 18Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 6C1 5.07069 1 4.60603 1.07686 4.21964C1.39249 2.63288 2.63288 1.39249 4.21964 1.07686C4.60603 1 5.07069 1 6 1C6.92931 1 7.39397 1 7.78036 1.07686C9.36712 1.39249 10.6075 2.63288 10.9231 4.21964C11 4.60603 11 5.07069 11 6C11 6.92931 11 7.39397 10.9231 7.78036C10.6075 9.36712 9.36712 10.6075 7.78036 10.9231C7.39397 11 6.92931 11 6 11C5.07069 11 4.60603 11 4.21964 10.9231C2.63288 10.6075 1.39249 9.36712 1.07686 7.78036C1 7.39397 1 6.92931 1 6Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 6C13 5.07069 13 4.60603 13.0769 4.21964C13.3925 2.63288 14.6329 1.39249 16.2196 1.07686C16.606 1 17.0707 1 18 1C18.9293 1 19.394 1 19.7804 1.07686C21.3671 1.39249 22.6075 2.63288 22.9231 4.21964C23 4.60603 23 5.07069 23 6C23 6.92931 23 7.39397 22.9231 7.78036C22.6075 9.36712 21.3671 10.6075 19.7804 10.9231C19.394 11 18.9293 11 18 11C17.0707 11 16.606 11 16.2196 10.9231C14.6329 10.6075 13.3925 9.36712 13.0769 7.78036C13 7.39397 13 6.92931 13 6Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgCustomization);
export default ForwardRef;
